module.exports = __webpack_public_path__ + "img/projects-img5.6c4cc116.jpg";